import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Welcome from './components/pages/Welcome';
import Login from './components/pages/Login';
import ForgotPassword from './components/pages/ForgotPassword';
import ResetPassword from './components/pages/ResetPassword';
import Sidebar from './components/Sidebar';
import AttendanceSettingEdit from './components/pages/AttendanceSettingEdit';
import ApiDocumentation from './components/pages/ApiDocumentation';
import DutiesTax from './components/pages/DutiesTax';


function App() {
  console.log(process.env.REACT_APP_ENV)
  return (
    <div className="App">
      <BrowserRouter>
        {/* <ScrollToTop> */}


        <Routes>

          <Route path="/" element={<Login />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/forgot-password" element={<ForgotPassword />}></Route>
          <Route path="/reset-password" element={<ResetPassword />}></Route>
          <Route path="/api-documentation" element={<ApiDocumentation />}></Route>
          <Route path="/duties-tax" element={<DutiesTax />}></Route>
          <Route path="/orders/*" element={<Sidebar />}></Route>
          <Route path="/entity/*" element={<Sidebar />}></Route>
          <Route path="/dashboard" element={<Sidebar />}></Route>

         
        
          {/* <Route path="/orders/attendance-setting/:id/edit" element={<AttendanceSettingEdit />} /> */}
        </Routes>

        {/* </ScrollToTop> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
